<template>
    <header class="header-global">
        <!-- <base-nav class="navbar-main" transparent type="" effect="light" expand>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <img class="header-logo"  src="/img/brand/roho-icon-only.png" alt="A logo with a orange pangolin surrounded by a blue circle. Brand name: Roho Network. Slogan: do better together.">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdl4lfnQDH7Bgf-30nOx_JDzrVqnLC1O8F4XBlcGee-TsHUDg/viewform?usp=sf_link" target="_blank" rel="noopener"
                        v-scroll-to="{
                            el: '#scrollto',
                            offset: 0,
                            duration: 1000
                        }"
                        class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                            <i class="fa fa-users mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">Our Team</span>
                    </a>
                </li>
            </ul>
        </base-nav> -->
        <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
            <img class="header-logo" src="/img/brand/roho-icon-only.png" alt="A logo with a orange pangolin surrounded by a blue circle. Brand name: Roho Network. Slogan: do better together.">
        </router-link>
        <router-link to="/about"><base-button
            tag="button"
            icon="fa fa-users"
            type="roho-blue">
            Our Team
        </base-button></router-link>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import BaseButton from "@/components/BaseButton";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    BaseButton
  },
};
</script>

<style>
    .navbar-main {
        margin: 30px 0 0 0;
    }

    .navbar-brand img.header-logo {
        height: 45px;
    }

    .header-global {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1040px;
        top: 25px;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 1000;
        width: 90%;
    }

    @media (min-width: 576px) {
        .header-global {
            max-width: 540px;
        }
    }

    @media (min-width: 768px) {
        .header-global {
            max-width: 720px;
        }
    }

    @media (min-width: 992px) {
        .header-global {
            max-width: 960px;
        }
    }

    @media (min-width: 1200px) {
        .header-global {
            max-width: 1040px;
        }
    }
</style>
